import { AiccLanguageStatus } from "constants/aiccLanguage";
import { AICC_PROMPT_GROUP_SLUG, AiccPromptGroup } from "constants/aiccPrompt";

/**
 * The screen's own URLs, in one place because two features build them: Language Management's Manage
 * buttons point at a tab, and the dashboard's rows point at a prompt.
 *
 * Under the existing `/aicc/prompts` menu entry rather than under Learning Assets — the module already
 * has its own place in the navigation, and a second path for the same screen would split it.
 */
export const AICC_PROMPT_ROOT_PATH = "/aicc/prompts";

export const aiccPromptPath = (group: AiccPromptGroup) => `${AICC_PROMPT_ROOT_PATH}/${AICC_PROMPT_GROUP_SLUG[group]}`;

/**
 * Which copy the row belonged to, carried in the URL.
 *
 * 🔴 THE STATUS OF THE TAB THAT WAS CLICKED IS WHAT DECIDES READ-ONLY, not the detail response's own
 * `editable` field, which is not trustworthy. So it travels with the link: in the query rather than in the
 * store, because the screen has to answer the same way after a refresh and for whoever the link is sent to.
 */
export const AICC_PROMPT_STATUS_PARAM = "status";

export const aiccPromptDetailPath = (group: AiccPromptGroup, promptKey: string, status?: AiccLanguageStatus) =>
  `${aiccPromptPath(group)}/${promptKey}${status ? `?${AICC_PROMPT_STATUS_PARAM}=${encodeURIComponent(status)}` : ""}`;
